import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import { neverReached as t } from "../../../core/compilerUtils.js";
import o from "../../../core/Evented.js";
import { property as r } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../../core/accessorSupport/decorators/subclass.js";

var p = /*#__PURE__*/function (_o$EventedAccessor) {
  _inherits(p, _o$EventedAccessor);

  var _super = _createSuper(p);

  function p(e) {
    var _this;

    _classCallCheck(this, p);

    _this = _super.call(this, e), _this.cancelled = !1, _this.history = {
      undo: [],
      redo: []
    }, _this.type = null;
    return _this;
  }

  _createClass(p, [{
    key: "tool",
    get: function get() {
      if (!this.activeComponent) return null;

      switch (this.activeComponent.type) {
        case "graphic-mover":
        case "move-3d":
          return "move";

        case "box":
        case "transform-3d":
          return "transform";

        case "reshape":
        case "reshape-3d":
          return "reshape";

        case "draw-2d":
        case "draw-3d":
          return this.activeComponent.geometryType;

        default:
          t(this.activeComponent);
      }

      return null;
    }
  }, {
    key: "addToHistory",
    value: function addToHistory(e) {
      this.history.redo = [], this.history.undo.push(e);
    }
  }, {
    key: "resetHistory",
    value: function resetHistory() {
      this.history.redo = [], this.history.undo = [];
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.history.undo.length > 0;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.history.redo.length > 0;
    }
  }, {
    key: "complete",
    value: function complete() {
      this.reset(), this.onEnd(), this.emit("complete");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.cancelled = !0, this.complete();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.activeComponent.reset();
    }
  }, {
    key: "refreshComponent",
    value: function refreshComponent() {
      var e = this.activeComponent;
      e && ("box" !== e.type && "reshape" !== e.type && "graphic-mover" !== e.type || e.refresh());
    }
  }, {
    key: "undo",
    set: function set(e) {
      var _this2 = this;

      this._set("undo", function () {
        _this2.canUndo() && e();
      });
    }
  }, {
    key: "redo",
    set: function set(e) {
      var _this3 = this;

      this._set("redo", function () {
        _this3.canRedo() && e();
      });
    }
  }]);

  return p;
}(o.EventedAccessor);

e([r()], p.prototype, "activeComponent", void 0), e([r()], p.prototype, "cancelled", void 0), e([r()], p.prototype, "history", void 0), e([r()], p.prototype, "tool", null), e([r()], p.prototype, "type", void 0), e([r()], p.prototype, "canUndo", null), e([r()], p.prototype, "canRedo", null), e([r()], p.prototype, "onEnd", void 0), e([r()], p.prototype, "undo", null), e([r()], p.prototype, "redo", null), e([r()], p.prototype, "toggleTool", void 0), e([r()], p.prototype, "addToSelection", void 0), e([r()], p.prototype, "removeFromSelection", void 0), p = e([s("esri.widgets.Sketch.support.OperationHandle")], p);

var n = /*#__PURE__*/function (_p) {
  _inherits(n, _p);

  var _super2 = _createSuper(n);

  function n() {
    _classCallCheck(this, n);

    return _super2.apply(this, arguments);
  }

  return n;
}(p);

e([r()], n.prototype, "activeComponent", void 0), n = e([s("esri.widgets.Sketch.support.CreateOperationHandle")], n);

var i = /*#__PURE__*/function (_p2) {
  _inherits(i, _p2);

  var _super3 = _createSuper(i);

  function i(e) {
    _classCallCheck(this, i);

    return _super3.call(this, e);
  }

  return i;
}(p);

e([r()], i.prototype, "activeComponent", void 0), i = e([s("esri.widgets.Sketch.support.UpdateOperationHandle")], i);
export { n as CreateOperationHandle, p as OperationHandle, i as UpdateOperationHandle };